import { render, staticRenderFns } from "./indexdel1.vue?vue&type=template&id=cafaeb90&scoped=true&"
import script from "./indexdel1.vue?vue&type=script&lang=js&"
export * from "./indexdel1.vue?vue&type=script&lang=js&"
import style0 from "./indexdel1.vue?vue&type=style&index=0&id=cafaeb90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafaeb90",
  null
  
)

export default component.exports